import { gql } from "apollo-angular";

export const GETALL_OFFBOARD_COMPONENTS_QUERY = gql`query configuratorAllOffboardComponents {
    configuratorAllOffboardComponents {
        Uid
        Name
    }
  }
  `
